/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface PayMateConnectorAssignmentDto
 */
export interface PayMateConnectorAssignmentDto {
    /**
     * 1-based connector index, matching Connector.ConnectorIndex
     * @type {number}
     * @memberof PayMateConnectorAssignmentDto
     */
    connectorIndex?: number;
    /**
     * The PayMate that sells this connector. In PUT requests, required and must be a child of the charger's linked PayMate. In GET responses: null if not sold by any terminal; otherwise either a child PayMate (split mode) or the charger's single linked PayMate (non-split mode) — see PayMateConnectorAssignmentsResponseDto.IsSplitAcrossPayMates.
     * @type {string}
     * @memberof PayMateConnectorAssignmentDto
     */
    payMateDeviceIdentity?: string;
    /**
     * Response only: connector type
     * @type {string}
     * @memberof PayMateConnectorAssignmentDto
     */
    connectorType?: PayMateConnectorAssignmentDtoConnectorTypeEnum;
    /**
     * Response only: customer-facing connector label, eg 'Port A'
     * @type {string}
     * @memberof PayMateConnectorAssignmentDto
     */
    connectorLabel?: string;
    /**
     * Response only: friendly name of the assigned PayMate
     * @type {string}
     * @memberof PayMateConnectorAssignmentDto
     */
    payMateFriendlyName?: string;
}

/**
 * @export
 */
export const PayMateConnectorAssignmentDtoConnectorTypeEnum = {
    Unknown: "Unknown",
    ChAdeMo: "CHAdeMO",
    Ccs: "CCS",
    Ccs2: "CCS2",
    Type1: "Type1",
    Type2: "Type2",
    Mcs: "MCS",
    Pantograph: "Pantograph",
    Domestic: "Domestic",
} as const;
export type PayMateConnectorAssignmentDtoConnectorTypeEnum =
    (typeof PayMateConnectorAssignmentDtoConnectorTypeEnum)[keyof typeof PayMateConnectorAssignmentDtoConnectorTypeEnum];

/**
 * Check if a given object implements the PayMateConnectorAssignmentDto interface.
 */
export function instanceOfPayMateConnectorAssignmentDto(
    value: object,
): value is PayMateConnectorAssignmentDto {
    return true;
}

export function PayMateConnectorAssignmentDtoFromJSON(
    json: any,
): PayMateConnectorAssignmentDto {
    return PayMateConnectorAssignmentDtoFromJSONTyped(json, false);
}

export function PayMateConnectorAssignmentDtoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): PayMateConnectorAssignmentDto {
    if (json == null) {
        return json;
    }
    return {
        connectorIndex:
            json["connectorIndex"] == null ? undefined : json["connectorIndex"],
        payMateDeviceIdentity:
            json["payMateDeviceIdentity"] == null
                ? undefined
                : json["payMateDeviceIdentity"],
        connectorType:
            json["connectorType"] == null ? undefined : json["connectorType"],
        connectorLabel:
            json["connectorLabel"] == null ? undefined : json["connectorLabel"],
        payMateFriendlyName:
            json["payMateFriendlyName"] == null
                ? undefined
                : json["payMateFriendlyName"],
    };
}

export function PayMateConnectorAssignmentDtoToJSON(
    value?: PayMateConnectorAssignmentDto | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        connectorIndex: value["connectorIndex"],
        payMateDeviceIdentity: value["payMateDeviceIdentity"],
        connectorType: value["connectorType"],
        connectorLabel: value["connectorLabel"],
        payMateFriendlyName: value["payMateFriendlyName"],
    };
}
